import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageHeader from '../../../layouts/PageHeader';
import { Sun } from 'lucide-react';
import VacationBalanceSection from './VacationBalanceAdminPage';
import SemesterskuldSection from './SemesterskuldPage';

/**
 * SemesterPage — unified Lön→Semester page.
 *
 * Two sections, deep-linkable as `#saldon` and `#skuld`:
 *   #saldon — per-employee earned/carried/saved days admin (VacationBalanceSection)
 *   #skuld  — semesterskuldsberäkning och bokning på 2940 (SemesterskuldSection)
 *
 * Why one page: semester admin happens in a single mental session — payroll
 * admin opens this area at year-end rollover (7 § accrual + semesterskuldsbokning),
 * not as separate tasks.
 */

const SemesterPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(hash.replace('#', ''));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [hash]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <PageHeader
        icon={Sun}
        title="Semester"
        subtitle="Semestersaldon per anställd och bokning av semesterskulden."
        actions={
          <>
            <button type="button" className="ll-btn ll-btn--ghost" onClick={() => scrollTo('saldon')}>Saldon</button>
            <button type="button" className="ll-btn ll-btn--ghost" onClick={() => scrollTo('skuld')}>Skuld</button>
          </>
        }
      />

      <div className="emp-detail__main" style={{ paddingBottom: '2.5rem' }}>
        <div id="saldon" style={{ scrollMarginTop: 16 }}>
          <VacationBalanceSection />
        </div>
        <div id="skuld" style={{ scrollMarginTop: 16 }}>
          <SemesterskuldSection />
        </div>
      </div>
    </>
  );
};

export default SemesterPage;
